"use client"
import { useEffect, useState } from "react"
import axios from "axios"
import Header from "./header"
import About from "./about"
import Skills from "./skills"
import ProjectsSection from "../client/ProjectsSection"
import Testimonials from "./testimonials"
import PaintSplatter from "./paint-splatter"
import { useParams } from "react-router-dom"
import { decryptId } from "../../utils/crypto"

// Define global styles
const globalStyles = `
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  html {
    scroll-behavior: smooth;
  }
  
  body {
    font-family: 'Inter', sans-serif;
    color: #1f2937;
    background-color: #ffffff;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .animate-fadeIn {
    animation: fadeIn 1s ease-out forwards;
  }
  
  /* Floating label effect */
  input:not(:placeholder-shown) + label,
  textarea:not(:placeholder-shown) + label,
  input:focus + label,
  textarea:focus + label {
    transform: translateY(-0.75rem) scale(0.75);
    color: #7749f8;
  }
`

const containerStyle = {
  padding: "4rem 1rem 1.25rem",
  position: "relative",
}

const flexContainerStyle = {
  maxWidth: "1200px",
  margin: "0 auto",
  zIndex: 10,
}

export default function Page() { 
  const [profile, setProfile] = useState(null);
  const { userId } = useParams();
  const decryptedUserId = decryptId(userId);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(`http://localhost:5000/profile/${decryptedUserId}`);
        const data = response.data
          ? {
              ...response.data,
              personal_image: response.data.personal_image
                ? decodeImage(response.data.personal_image)
                : "",
              transcripts: [
                response.data.transcript_upload1,
                response.data.transcript_upload2,
                response.data.transcript_upload3,
                response.data.transcript_upload4,
                response.data.transcript_upload5,
              ]
                .filter((transcript) => transcript !== null)
                .map(decodeImage),
            }
          : null;
        setProfile(data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };
    fetchProfile();
  }, []);

  const decodeImage = (base64String) => {
    const format = base64String.startsWith("/") ? "png" : "jpg";
    return `data:image/${format};base64,${base64String}`;
  };

  return (
    <>
      <style>{globalStyles}</style>
          <Header profile={profile} />
          <About profile={profile} />
          <Skills profile={profile} />
       
      <div style={containerStyle} id="projects">
        <PaintSplatter position="bottom-right" size="md" opacity={0.15} rotation={15} />
        <PaintSplatter position="top-left" size="sm" opacity={0.2} rotation={-20} />
        <div style={flexContainerStyle}>
          <ProjectsSection userId={decryptedUserId} />
        </div>
      </div>
      <Testimonials profile={profile} />
    </>
  );
}

